import { render, staticRenderFns } from "./event-stats.vue?vue&type=template&id=9ea54264&"
import script from "./event-stats.vue?vue&type=script&lang=js&"
export * from "./event-stats.vue?vue&type=script&lang=js&"
import style0 from "./event-stats.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../../rubis-bi/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports